import { Link, useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import { useState } from "react";
import Logo from "@assets/img/logo";
import { ROUTES } from "src/router/routes";
import USA from "@assets/img/FlagUS.png";
import Canada from "@assets/img/FlagCanada.png";
import Mexico from "@assets/img/FlagMexico.png";

const marketplaces = [
  { id: "usa", label: "USA", flag: USA },
  {
    id: "canada",
    label: "Canada",
    flag: Canada,
  },
  {
    id: "mexico",
    label: "Mexico",
    flag: Mexico,
  },
];

export const AmazonSellerAccount = () => {
  const [selectedRegion, setSelectedRegion] = useState("");
  const nav = useNavigate();

  const handleNext = () => {
    if (selectedRegion) {
      nav("/to-be-redirected");
    } else {
      alert("Please select a region");
    }
  };

  return (
    <div className={styles.page}>
      <Link to={ROUTES.ROOT}>
        <Logo color="black" />
      </Link>
      <h1>Connect to your Seller Account</h1>
      <h2>Choose the Amazon marketplace region</h2>

      <div className={styles.marketplaceGrid}>
        {marketplaces.map((marketplace) => (
          <label
            key={marketplace.id}
            className={`${styles.card} ${selectedRegion === marketplace.id ? styles.active : ""}`}
          >
            <div className={styles.inLine}>
              <input
                type="radio"
                name="region"
                value={marketplace.id}
                onChange={() => setSelectedRegion(marketplace.id)}
              />
              <span style={{ color: "black", marginBottom: "2px" }}>
                {marketplace.label}
              </span>
            </div>
            <img
              src={marketplace.flag}
              alt={marketplace.label}
              className={styles.flag}
            />
          </label>
        ))}
      </div>

      <div className={styles.buttons}>
        <button className={styles.back} onClick={() => nav(-1)}>
          ← Back
        </button>
        <button className={styles.connect} onClick={() => handleNext()}>
          Connect to Seller Central →
        </button>
      </div>

      <button className={styles.skip} onClick={() => nav("/account-success")}>
        Skip
      </button>
    </div>
  );
};
